import { render, staticRenderFns } from "./PDBasic.vue?vue&type=template&id=bca41576&scoped=true"
import script from "./PDBasic.vue?vue&type=script&lang=js"
export * from "./PDBasic.vue?vue&type=script&lang=js"
import style0 from "./PDBasic.vue?vue&type=style&index=0&id=bca41576&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca41576",
  null
  
)

export default component.exports